// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router'
import DownloadViews from '../views/DownloadViews.vue'
import NoticeViews from '../views/NoticeViews.vue'
import NoticeDetailViews from '../views/NoticeDetailViews.vue'
import ContentViews from '../views/ContentViews.vue'
import ContentDetailViews from '../views/ContentDetailViews.vue'
import ContentNoticeDetailViews from '../views/ContentNoticeDetailViews.vue'
import IndexViews from '../views/IndexViews.vue'
import FaqViews from '../views/FaqViews.vue'
import InquiryViews from '../views/InquiryViews.vue'
import InquiryCompleteViews from '../views/InquiryCompleteViews.vue'
import LoginViews from '../views/LoginViews.vue'
import OacxPopupViews from '../views/OacxPopupViews.vue'
import CivsPopupViews from '../views/CivsPopupViews.vue'
import CivsResultPopupViews from '../views/CivsResultPopupViews.vue'
import MypageViews from '../views/MypageViews.vue'
import MypagePWChangeViews from '../views/MypagePWChangeViews.vue'
import MypageModifyConfirmViews from '../views/MypageModifyConfirmViews.vue'
import MypageModifyViews from '../views/MypageModifyViews.vue'
import FindIDViews from '../views/FindIDViews.vue'
import FindIDMaskingView from '../views/FindIDMaskingView.vue'
import FindIDAllViews from '../views/FindIDAllViews.vue'
import FindIDNoneMaskingView from '../views/FindIDNoneMaskingView.vue'
import FindPWViews from '../views/FindPWViews.vue'
import FindPWChangeViews from '../views/FindPWChangeViews.vue'
import WithdrawalViews from '../views/WithdrawalViews.vue'
import WithdrawalCompleteViews from '../views/WithdrawalCompleteViews.vue'
import WithdrawalCompleteMessageViews from '../views/WithdrawalCompleteMessageViews.vue'
import AgreeTrem from '../views/AgreeTrem.vue'
import JoinEnterView from '../views/JoinEnterView.vue'
import JoinStepView from '../views/JoinStepView.vue'
import JoinStepTwo from '../components/JoinStepTwo.vue'
import WelcomeView from '../views/WelcomeView.vue'
import privacyPolicy from '../views/privacyPolicy.vue'
import OrderFailed from '../views/OrderFailed.vue'
import OrderCompleted from '../views/OrderCompleted.vue'
import Order from '../views/Order.vue'
import OrderPay from '../views/OrderPay.vue'
import OrderList from '../views/OrderList.vue'
// import OrderTest from '../components/OrderTest.vue'
// import OrderRefund from '../components/OrderRefund.vue'

import termsView from '../agree/termsText.vue'
import marketingView from '../agree/marketingText.vue'
import privacyView from '../agree/privacyText.vue'

const routes = [
  {
    path: '/termsView',
    name: 'termsView',
    component: termsView,
  },
  {
    path: '/marketingView',
    name: 'marketingView',
    component: marketingView,
  },
  {
    path: '/privacyView',
    name: 'privacyView',
    component: privacyView,
  },
  {
    path: '/',
    name: 'IndexViews',
    component: IndexViews,
  },
  {
    path: '/contents',
    name: 'ContentViews',
    component: ContentViews,
  },
  {
    path: '/contents/:contentsId',
    name: 'ContentDetailViews',
    component: ContentDetailViews,
  },
  {
    path: '/contents/:contentsId/notice/:noticeId',
    name: 'ContentNoticeDetailViews',
    component: ContentNoticeDetailViews,
  },
  {
    path: '/download',
    name: 'DownloadViews',
    component: DownloadViews,
  },
  {
    path: '/notice',
    name: 'NoticeViews',
    component: NoticeViews,
  },
  {
    path: '/notice/:noticeId',
    name: 'NoticeDetailViews',
    component: NoticeDetailViews,
  },
  {
    path: '/faq',
    name: 'FaqViews',
    component: FaqViews,
  },
  {
    path: '/inquiry',
    name: 'InquiryViews',
    component: InquiryViews,
  },
  {
    path: '/inquiry_complete',
    name: 'InquiryCompleteViews',
    component: InquiryCompleteViews,
  },
  {
    path: '/login',
    name: 'LoginViews',
    component: LoginViews,
  },
  {
    path: '/oacx',
    name: 'OacxPopupViews',
    component: OacxPopupViews,
  },
  {
    path: '/civs',
    name: 'CivsPopupViews',
    component: CivsPopupViews,
  },
  {
    // 위에서 팝업창 요청시에 return URL로 던져줘야함
    path: '/civs_result',
    name: 'CivsResultPopupViews',
    component: CivsResultPopupViews,
  },
  {
    path: '/find_id',
    name: 'FindIDViews',
    component: FindIDViews,
  },
  {
    path: '/find_id',
    name: 'FindIDMaskingView',
    component: FindIDMaskingView,
  },
  {
    path: '/find_id_all',
    name: 'FindIDAllViews',
    component: FindIDAllViews,
  },
  {
    path: '/find_id_all',
    name: 'FindIDNoneMaskingView',
    component: FindIDNoneMaskingView,
  },
  {
    path: '/find_pw',
    name: 'FindPWViews',
    component: FindPWViews,
  },
  {
    path: '/find_pw_complete',
    name: 'FindPWChangeViews',
    component: FindPWChangeViews,
  },
  {
    path: '/mypage',
    name: 'MypageViews',
    component: MypageViews,
  },
  {
    path: '/mypage_password_change',
    name: 'MypagePWChangeViews',
    component: MypagePWChangeViews,
  },
  {
    path: '/mypage_pwd',
    name: 'MypageModifyConfirmViews',
    component: MypageModifyConfirmViews,
  },
  {
    path: '/mypage_modify',
    name: 'MypageModifyViews',
    component: MypageModifyViews,
  },
  {
    path: '/withdrawal',
    name: 'WithdrawalViews',
    component: WithdrawalViews,
  },
  {
    path: '/withdrawal_complete',
    name: 'WithdrawalCompleteViews',
    component: WithdrawalCompleteViews,
  },
  {
    path: '/withdrawal_complete_message',
    name: 'WithdrawalCompleteMessageViews',
    component: WithdrawalCompleteMessageViews,
  },
  {
    path: '/join',
    name: 'JoinEnterView',
    component: JoinEnterView,
  },
  {
    path: '/join_step',
    name: 'JoinStepView',
    component: JoinStepView,
  },
  {
    path: '/join_step_init',
    name: 'JoinStepTwo',
    component: JoinStepTwo,
  },
  {
    path: '/welcomeMeta',
    name: 'WelcomeView',
    component: WelcomeView,
  },
  {
    path: '/AgreeTrem',
    name: 'AgreeTrem',
    component: AgreeTrem,
  },
  {
    path: '/privacy_policy',
    name: 'privacyPolicy',
    component: privacyPolicy,
  },
  {
    path: '/order_completed',
    name: 'OrderCompleted',
    component: OrderCompleted,
  },
  {
    path: '/order_failed',
    name: 'OrderFailed',
    component: OrderFailed,
  },
  {
    path: '/order',
    name: 'Order',
    component: Order,
  },
  {
    path: '/order_pay',
    name: 'OrderPay',
    component: OrderPay,
  },
  {
    path: '/order_list',
    name: 'OrderList',
    component: OrderList,
  },
  // {
  //   path: '/order_test',
  //   name: 'OrderTest',
  //   component: OrderTest,
  // },
  // {
  //   path: '/order_refund',
  //   name: 'OrderRefund',
  //   component: OrderRefund,
  // },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: IndexViews, // 아직 NotFoundPage가 존재하지 않음.
    // component: NotFoundPage, // 아직 NotFoundPage가 존재하지 않음.
    redirect: '/', // 설정되지 않은 모든 경로 리디렉션
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 특정 경로('/contents')로 이동할 때 페이지 최상단으로 스크롤
    if (to.path === '/contents' || to.path.startsWith('/contents/')) {
      return { top: 0 }
    }
    return savedPosition || { top: 0 }
  },
})

/*
const movoeToOrderPage = () => {
  if (totalAmount.value === 0) {
    errStatus.value = true
    errCost.value = true
    errMsg.value = '결제하실 금액이 없습니다.'
  } else {
    orderData.value = {
      contentsIdx: detailData.value.idx,
      contentsTitle: detailData.value.title,
      contentsAmt: detailData.value.amt,
      opt1: selectedOpt1.value ? selectedOpt1.value : { label: '선택안함', cost: 0 },
      opt2: selectedOpt2.value ? selectedOpt2.value : { label: '선택안함', cost: 0 },
      totalAmount: totalAmount.value,
    }
    localStorage.setItem('orderData', JSON.stringify(orderData.value))
    router.push({ path: '/order' })
  }
}
*/

export default router
